import { CarePlanStatusEnum } from '../../Enum/CarePlanStatusEnum';
import BaseEntity from '../BaseEntity.model';
import { Barrier } from './Barrier.model';
import { Goal } from './Goal.model';
import { Metric } from './Metric.model';
import { NextStep } from './NextStep.model';
import { Plan } from './Plan.model';
import { ReviewHistory } from './ReviewHistory.model';
import { SchedulePlan } from './SchedulePlan.model';
import { Strength } from './Strength.model';

// New object-with-boolean structure
export interface ModeOfServiceDelivery {
    Home: boolean;
    Community: boolean;
    Office: boolean;
    Telehealth: boolean;
    Phone: boolean;
}

export interface Participants {
    Member: boolean;
    ChpProvider: boolean;
    Guardian: boolean;
    Family: boolean;
    Cm: boolean;
    BehavioralHealthHome: boolean;
    PeerSupport: boolean;
    Other: boolean;
    OtherNote: string;
}

export interface ServicesProvided {
    Counseling: boolean;
    PhysicalHealth: boolean;
    Sdoh: boolean;
    LifeSkills: boolean;
    CaseManagement: boolean;
    MedicationManagement: boolean;
    Other: boolean;
    OtherNote: string;
}

export interface IIntegratedCarePlan extends BaseEntity {
    MemberId: string;
    Goals: Goal[];
    Barriers: Barrier[];
    Plans: Plan[];
    Metrics: Metric[];
    NextSteps: NextStep[];
    Strengths: Strength[];
    SchedulePlans: SchedulePlan[];
    Status: CarePlanStatusEnum;
    CreatedBy: string;
    CreationTime: string;
    LastUpdatedBy: string;
    LastUpdatedTime: string;
    ApprovedBy: string;
    ApprovedTime: string;
    RejectedBy: string;
    RejectedTime: string;
    ReasonForRejection: string;
    ReviewHistory: ReviewHistory[];
    ReviewHistoryMember: ReviewHistory[];
    ShareWithMember: boolean;
    // New UI fields (object with booleans)

    Participants: Participants;
    Narrative: string;
    ServicesProvided: ServicesProvided;
    IsReviewed: boolean;
    IsReviewedDate: string | null;
}

export class IntegratedCarePlan implements IIntegratedCarePlan {
    Id: string | null;
    MemberId: string;
    Goals: Goal[];
    Barriers: Barrier[];
    Plans: Plan[];
    Metrics: Metric[];
    NextSteps: NextStep[];
    Strengths: Strength[];
    SchedulePlans: SchedulePlan[];
    Status: CarePlanStatusEnum;
    CreatedBy: string;
    CreationTime: string;
    LastUpdatedBy: string;
    LastUpdatedTime: string;
    ApprovedBy: string;
    ApprovedTime: string;
    RejectedBy: string;
    RejectedTime: string;
    ReasonForRejection: string;
    ReviewHistory: ReviewHistory[];
    ReviewHistoryMember: ReviewHistory[];
    ShareWithMember: boolean;

    Participants: Participants;
    Narrative: string;
    ServicesProvided: ServicesProvided;
    IsReviewed: boolean;
    IsReviewedDate: string | null;

    constructor() {
        this.Id = null;
        this.MemberId = '';
        this.Goals = [] as Goal[];
        this.Barriers = [] as Barrier[];
        this.Plans = [] as Plan[];
        this.Metrics = [] as Metric[];
        this.NextSteps = [] as NextStep[];
        this.Strengths = [] as Strength[];
        this.SchedulePlans = [] as SchedulePlan[];
        this.Status = CarePlanStatusEnum.Pending;
        this.ReviewHistory = [];
        this.ReviewHistoryMember = [];
        this.ShareWithMember = false;
        this.IsReviewed = false;
        this.IsReviewedDate = null;
        // New UI fields (object with booleans)
        this.Participants = {
            Member: false,
            ChpProvider: false,
            Guardian: false,
            Family: false,
            Cm: false,
            BehavioralHealthHome: false,
            PeerSupport: false,
            Other: false,
            OtherNote: '',
        };
    }
}
